var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.66683 1.83337C7.66683 1.56816 7.56147 1.3138 7.37394 1.12627C7.1864 0.938731 6.93205 0.833374 6.66683 0.833374C6.40161 0.833374 6.14726 0.938731 5.95972 1.12627C5.77219 1.3138 5.66683 1.56816 5.66683 1.83337V6.16671H1.3335C1.06828 6.16671 0.813926 6.27206 0.626389 6.4596C0.438853 6.64714 0.333496 6.90149 0.333496 7.16671C0.333496 7.43192 0.438853 7.68628 0.626389 7.87381C0.813926 8.06135 1.06828 8.16671 1.3335 8.16671H5.66683V12.5C5.66683 12.7653 5.77219 13.0196 5.95972 13.2071C6.14726 13.3947 6.40161 13.5 6.66683 13.5C6.93205 13.5 7.1864 13.3947 7.37394 13.2071C7.56147 13.0196 7.66683 12.7653 7.66683 12.5V8.16671H12.0002C12.2654 8.16671 12.5197 8.06135 12.7073 7.87381C12.8948 7.68628 13.0002 7.43192 13.0002 7.16671C13.0002 6.90149 12.8948 6.64714 12.7073 6.4596C12.5197 6.27206 12.2654 6.16671 12.0002 6.16671H7.66683V1.83337Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAdd);
export default __webpack_public_path__ + "static/media/ic-add.75f89bb1990dfb9e445fa3f4d3776356.svg";
export { ForwardRef as ReactComponent };